import styles from "./Footer.module.scss";
import logoBlueSvg from "../../assets/images/get-in-touch/logo-blue.svg";
import {useTranslation} from "react-i18next";
import {getLogo} from "../../helpers/image.helper";
import {NavLink, useNavigate} from "react-router-dom";
import useAppSelector from "../../hooks/useAppSelector";
import {getLanguageFromLocal, languageList} from "../../helpers/language.helper";
import selectArrowWhite from "../../assets/images/icons/select-arrow-white.svg";
import languageWhite from "../../assets/images/icons/language-white.svg";
import {useState} from "react";
import {SiteContentService} from "../../services/siteContent.service";
import {setSiteContent} from "../../store/siteContent/siteContentSlice";
import useAppDispatch from "../../hooks/useAppDispatch";

const Footer = () => {

    const navigate = useNavigate();
    const {t, i18n} = useTranslation();
    const dispatch = useAppDispatch();

    const {generalSettings} = useAppSelector(state => state.generaContentSettingsSlice);

    const [isLanguageSelectActive, setIsLanguageSelectActive] = useState<boolean>(false);

    const clickOnLogo = () => {
        navigate("/")
    }

    const clickOnLanguageBtn = () => {
        setIsLanguageSelectActive(!isLanguageSelectActive);
    }

    const clickOnLanguageItem = (value: string) => {
        localStorage.setItem("selectedLanguage", value);
        i18n.changeLanguage(value);
        getSiteContent(value);
    }

    const getActiveLanguage = () => {
        if (getLanguageFromLocal() === "en") {
            return "English";
        } else {
            return "Greek"
        }
    }

    const getSiteContent = async (language: string) => {
        try {
            const response = await SiteContentService.getSiteContent(language);
            if (response.data && response.status === 200) {
                dispatch(setSiteContent(response.data));
            }
        } catch (e) {}
    }

    return (
        <footer className={styles.footer}>
            <div className={"container"}>
                <div className={styles.row}>
                    <div className={styles.logo}>
                        <img onClick={clickOnLogo} src={getLogo(generalSettings.logoPath)}
                             alt={"logo"}/>
                    </div>
                    <ul className={styles.menu}>
                        <li>
                            <NavLink
                                className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                to={"/services"}
                            >
                                {t("Services")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                to={"/plans"}
                            >
                                {t("Plans")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                to={"/trainers"}
                            >
                                {t("Trainers")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                to={"/schedule"}
                            >
                                {t("Schedule")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                                to={"/venues"}
                            >
                                {t("Venues")}
                            </NavLink>
                        </li>
                    </ul>
                    <div onClick={clickOnLanguageBtn}
                         className={`${styles.language} ${isLanguageSelectActive && styles.languageActive}`}>
                        <img src={languageWhite} alt={"language"}/>
                        <p>{getActiveLanguage()}</p>
                        <img src={selectArrowWhite} alt={"arrow"}/>
                        {
                            isLanguageSelectActive && (
                                <ul className={styles.languageDropdown}>
                                    {
                                        languageList.map(el => {
                                            return (
                                                <li
                                                    onClick={() => clickOnLanguageItem(el.key)}
                                                    className={`${getLanguageFromLocal() === el.key && styles.activeLanguageItem}`}
                                                    key={el.key}
                                                >
                                                    {el.label}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            )
                        }
                    </div>
                </div>
                <ul className={`${styles.menu} ${styles.mobile}`}>
                    <li>
                        <NavLink
                            className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                            to={"/services"}
                        >
                            {t("Services")}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                            to={"/plans"}
                        >
                            {t("Plans")}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                            to={"/trainers"}
                        >
                            {t("Trainers")}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                            to={"/schedule"}
                        >
                            {t("Schedule")}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            className={prop => prop.isActive ? `${styles.link} ${styles.linkActive}` : `${styles.link}`}
                            to={"/venues"}
                        >
                            {t("Venues")}
                        </NavLink>
                    </li>
                </ul>

                <div className={styles.poweredBy}>
                    <p>{t("PoweredBy")}:</p>
                    <a href={getLanguageFromLocal() === "en" ? "https://trainyourpulse.com" : "https://trainyourpulse.gr"} target={"_blank"}>
                        <img src={logoBlueSvg} alt={"logo"}/>
                    </a>
                </div>

            </div>

        </footer>
    )
}

export default Footer;